// ForgotPasswordPage.jsx — Passwort vergessen (/forgot-password)
//
// 18.10.2026: im Design der Anmeldeseite (AnmeldenPage.css, rot, hell/dunkel)
// und für alle Konten mit E-Mail-Adresse: Verwaltung und Vereine
// (Link auf /reset-password) und Turnierpersonal (Link auf
// /personal-zugang/…). Die Antwort ist immer dieselbe, auch für unbekannte
// Adressen — sie verrät nicht, ob es ein Konto gibt.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AnmeldenPage.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.success) setSent(true);
      else setError(r.status === 429 ? 'Zu viele Versuche. Bitte 15 Minuten warten.' : (d.error || `Fehler ${r.status}`));
    } catch { setError('Keine Verbindung. Bitte erneut versuchen.'); }
    finally { setLoading(false); }
  }

  return (
    <div className="anm-seite">
      <div className="anm-karte">
        <div className="anm-kopf">
          <Link to="/" className="anm-logo-link" aria-label="Zur Startseite">
            <img src="/logo.webp" alt="TDA" className="anm-logo" width="64" height="64" />
          </Link>
          <span className="anm-marke">TDA Tournament Center</span>
          <h1>Passwort vergessen</h1>
          <p>Für Verwaltung, Vereine und Turnierpersonal mit hinterlegter E-Mail-Adresse.</p>
        </div>
        {sent ? (
          <div className="anm-form">
            <div className="anm-erfolg" role="status">
              Wenn zu dieser Adresse ein Konto gehört, ist die E-Mail unterwegs. Der Link gilt eine Stunde und nur einmal.
            </div>
            <Link to="/anmelden" className="anm-knopf" style={{ textAlign: 'center', textDecoration: 'none' }}>Zur Anmeldung</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="anm-form">
            <label className="anm-feld">E-Mail-Adresse
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading}
                autoComplete="email" autoCapitalize="none" autoFocus />
            </label>
            {error && <div className="anm-fehler" role="alert">{error}</div>}
            <button type="submit" className="anm-knopf" disabled={loading}>{loading ? 'Wird gesendet…' : 'Link anfordern'}</button>
            <p className="anm-grau anm-fuss">
              Ohne E-Mail-Adresse (z. B. Kampfrichter mit Zugangszettel): bitte beim Veranstalter einen neuen Einladungslink anfordern.
              Athleten: Passwort in <a href="https://my.tda-intl.org">Mein TDA</a> zurücksetzen.
            </p>
          </form>
        )}
      </div>
      <Link to="/anmelden" className="anm-zurueck">← Zur Anmeldung</Link>
    </div>
  );
}
